module.exports = __webpack_public_path__ + "static/media/segmento-cosmetico.2b2d15e0.gif";